import { type Recyclable } from '../types.ts';

import { tryDispatchDatabaseLoadFromCurrentBridge } from './try-dispatch-database-load-from-current-bridge.ts';

/**
 * Recyclable that runs {@link tryDispatchDatabaseLoadFromCurrentBridge} when identity recycles.
 * Uses `skipInitialSetup` so the first `registerRecyclableModules` pass does not run `setup`; cold-start
 * load is dispatched from `app/index.tsx` after `bootstrap()` (intl and feature flags ready first).
 */
export function createBridgeDatabaseLoadDispatchRecyclable(): Recyclable {
  return {
    skipInitialSetup: true,
    setup() {
      tryDispatchDatabaseLoadFromCurrentBridge();
    },
    dispose() {},
  };
}
